<div class="icon-nav">
  <ul>
    <li class="onhover-div mobile-search search-widgets" id="search-widgets">
      <a (click)="laCascadaProductService.searchToggle()">
        <img src="assets/la-cascada/icons/search_black.svg" title="Buscar" class="img-fluid" alt="icon">
        <img src="assets/la-cascada/icons/search_white.svg" class="img-fluid mobile" alt="icon">
      </a>
    </li>
    <li class="onhover-div mobile-search search-widgets" id="notification">
        <a (click)="laCascadaProductService.searchToggleOff()" class="shoppingCartCount onhover-dropdown custom">
          <img routerLink="/home/notifications" src="../../../../assets/la-cascada/icons/notification.svg" title="Notificaciones" class="img-fluid" alt="icon">
          <img routerLink="/home/notifications" src="../../../../assets/la-cascada/icons/notification_white.svg" class="img-fluid mobile" alt="icon">
          <div class="count-inner" *ngIf="laCascadaProductService.notifications_to_show.length != 0">{{ laCascadaProductService.notifications_to_show.length }}</div>
          <ul class="onhover-show-div" *ngIf="laCascadaProductService.notifications_to_show.length == 0 && router.url != '/home/notifications'">
            <li> No tienes notificaciones por el momento </li>
          </ul>
          <ul class="onhover-show-div" *ngIf="laCascadaProductService.notifications_to_show.length != 0 && router.url != '/home/notifications'">
            <li *ngFor="let notification of laCascadaProductService.notifications_to_show" (click)="markAsReaded(notification.pkyNotification, notification.fldType)" >
              <div class="d-flex justify-content-between gap-2 flex-wrap">
                <b> <img src="../../../../assets/la-cascada/icons/notification_bold.svg" class="img-fluid" alt="icon"> {{ notification.fldName }}</b>
                <span>{{ notification.formatDate }}</span>
              </div>
              <p>{{ notification.fldMessage }}</p>
            </li>
          </ul>
        </a>
    </li>
    <li class="onhover-div mobile-search search-widgets" id="likes">
      <a routerLink="/home/favorites" (click)="laCascadaProductService.searchToggleOff()" class="shoppingCartCount">
          <img src="../../../../assets/la-cascada/icons/heart.svg" title="Favoritos" class="img-fluid" alt="icon">
          <img src="../../../../assets/la-cascada/icons/heart_white.svg" class="img-fluid mobile" alt="icon">
          <div class="count-inner" *ngIf="!laCascadaProductService.objetEmpty(favorites)">{{ favorites?.length }}</div>
      </a>
    </li>
    <li class="onhover-div mobile-search search-widgets" id="shop-car">
      <a (click)="[laCascadaProductService.searchToggleOff(), hideShoppingWidget()]" class="shoppingCartCount desktop">
        <img src="../../../../assets/la-cascada/icons/buy_black.svg" title="Carrito de compras" class="img-fluid" alt="icon">
        <div class="count-inner" *ngIf="!laCascadaProductService.objetEmpty(shoppingCart)">{{ shoppingCart?.storage_cart_detail.length }}</div>
      </a>
      <a routerLink="/home/shopping-cart" (click)="laCascadaProductService.searchToggleOff()" class="shoppingCartCount mobile">
        <!-- <img src="../../../../assets/la-cascada/icons/buy_white.svg" class="img-fluid" alt="icon"> -->
        <img src="../../../../assets/la-cascada/icons/buy_white.svg" class="img-fluid mobile" alt="icon">
        <div class="count-inner" *ngIf="!laCascadaProductService.objetEmpty(shoppingCart)">{{ shoppingCart?.storage_cart_detail.length }}</div>
      </a>
    </li>
    <!-- <li class="onhover-div mobile-setting">
      <div><img src="assets/images/icon/setting.png" class="img-fluid" alt="settong">
        <i class="ti-settings"></i></div>
      <div class="show-div setting">
        <h6>language</h6>
        <ul>
          <li *ngFor="let language of languages">
            <a href="javascript:void(0)" (click)="changeLanguage(language.code)">{{ language.name }}</a>
          </li>
        </ul>
        <h6>currency</h6>
        <ul class="list-inline">
          <li *ngFor="let currency of currencies">
            <a href="javascript:void(0)" (click)="changeCurrency(currency)">{{ currency.name }}</a>
          </li>
        </ul>
      </div>
    </li> -->
    <!-- <li class="onhover-div mobile-cart">
      <div>
        <a [routerLink]="['/shop/cart']">
          <img src="assets/images/icon/cart.png" class="img-fluid" alt="">
          <i class="ti-shopping-cart"></i>
        </a>
      </div>
      <span class="cart_qty_cls">{{ products.length }}</span>
      <ul class="show-div shopping-cart" *ngIf='!products.length'>
        <h5>Your cart is currently empty.</h5>
      </ul>
      <ul class="show-div shopping-cart" *ngIf='products.length'>
        <li *ngFor="let product of products">
          <div class="media">
            <a [routerLink]="['/shop/product/left/sidebar/', product.title.replace(' ', '-')]">
              <img class="me-3" [src]="product?.images[0].src" [alt]="product?.images[0].alt">
            </a>
            <div class="media-body">
              <a [routerLink]="['/shop/product/left/sidebar/', product.title.replace(' ', '-')]">
                <h4>{{ product?.title }}</h4>
              </a>
              <h4>
                <span>
                  {{ product?.quantity }} x 
                  {{ product?.price * productService?.Currency.price | discount:product | currency:productService?.Currency.currency:'symbol' }}
                </span>
              </h4>
            </div>
          </div>
          <div class="close-circle" (click)="removeItem(product)">
            <a href="javascript:void(0)"><i class="fa fa-times" aria-hidden="true"></i></a>
          </div>
        </li>
        <li>
          <div class="total">
            <h5>subtotal : <span>{{ getTotal | async | currency:productService?.Currency.currency:'symbol' }}</span></h5>
          </div>
        </li>
        <li>
          <div class="buttons">
            <a [routerLink]="['/shop/cart']" class="view-cart">view cart</a>
            <a [routerLink]="['/shop/checkout']" class="checkout">checkout</a>
          </div>
        </li>
      </ul>
    </li> -->
  </ul>
</div>
